import {
  apiRegister
} from '../../common/api'
import {
  isArray
} from 'util'
import {
  map,
  isOkId,
  isPlain
} from '../../utils/base'
import {
  KCourse,
  KCourseWare
} from '../../models/k-course'
import {
  NO_ERROR,
  ERR_REP,
  ERR_REQ_COURSE_ID,
  // ERR_REQ_CATEGORY_ID,
  ERR_REQ_UID,
  ERR_REP_DATA_COURSE
} from '../../const'
import {
  CourseCategory
} from '../../models/course-category'

export const courseCategoriesLoad = apiRegister('courseCategoriesLoad', {
  protoId: 972,
  path: '/xsh/course/categories/',
  checkResult(R) {
    if (isPlain(R.list)) {
      return NO_ERROR
    }
    return ERR_REP
  },
  formatResult(R) {
    // R.info = KCourse(R.info)
    return new CourseCategory(R.list)
  }
}).send

export const courseInfo = apiRegister('courseInfo', {
  protoId: 973,
  path: '/xsh/course/detail/',
  checkQuery(Q) {
    if (!isOkId(Q.cid)) {
      return ERR_REQ_COURSE_ID
    }
    return NO_ERROR
  },
  checkResult({
    course
  }) {
    if (!isPlain(course)) {
      return ERR_REP_DATA_COURSE
    }
    return NO_ERROR
  },
  formatResult({
    isTeacher,
    course,
    coursewares,
    teachers
  }) {
    isTeacher = isTeacher > 0 ? +isTeacher : 0
    course = KCourse(course)
    // console.log(JSON.stringify(coursewares))
    coursewares = isArray(coursewares) ? map(coursewares, cw => KCourseWare(cw)) : []
    return {
      isTeacher,
      course,
      coursewares,
      teachers
    }
  }
}).send

// 课程权限检测
export const coursePower = apiRegister('coursePower', {
  protoId: 988,
  path: '/xsh/course/check/power/',
  checkQuery(Q) {
    if (!isOkId(Q.cid)) {
      return ERR_REQ_COURSE_ID
    } else if (!isOkId(Q.uid)) {
      return ERR_REQ_UID
    }
    return NO_ERROR
  },
  formatResult(R) {
    const order = R.order
    R.order = order && order.orderId ? order : null
    return R
  }
}).send

export const courseListLoad = apiRegister('courseListLoad', {
  protoId: 970,
  path: '/xsh/course/list/',
  formatQuery(Q) {
    const top = Q.top > 0 ? Q.top : 0
    const page = Q.page > 0 ? +Q.page : 1
    const pageNum = Q.pageNum > 0 ? +Q.pageNum : 20
    return {
      ...Q,
      top,
      page,
      pageNum
    }
  },
  formatResult(R) {
    R.list = isArray(R.list) ? map(R.list, c => KCourse(c)) : []
    return R
  }
}).send

// 980	xsh/course	/xsh/course/my/courses/
export const myPurchasedCoursesLoad = apiRegister('myPurchasedCoursesLoad', {
  protoId: 980,
  path: '/xsh/course/my/courses/',
  // checkQuery(Q) {
  //   return NO_ERROR
  // },
  formatQuery(Q) {
    const page = Q.page > 0 ? +Q.page : 1
    const pageNum = Q.pageNum > 0 ? +Q.pageNum : 20
    return {
      ...Q,
      page,
      pageNum
    }
  },
  formatResult(R) {
    R.list = isArray(R.list) ? map(R.list, c => KCourse(c)) : []
    return R
  }
}).send
// 979	xsh/course	/xsh/course/teacher/courses/
export const teacherCoursesLoad = apiRegister('teacherCoursesLoad', {
  protoId: 979,
  path: '/xsh/course/teacher/courses/',
  // checkQuery(Q) {
  //   // if(!isOkId(Q.uid)) {
  //   //   return ERR_REQ_UID
  //   // }
  //   return NO_ERROR
  // },
  formatQuery(Q) {
    const page = Q.page > 0 ? +Q.page : 1
    const pageNum = Q.pageNum > 0 ? +Q.pageNum : 20
    return {
      ...Q,
      page,
      pageNum
    }
  },
  formatResult(R) {
    R.list = isArray(R.list) ? map(R.list, c => KCourse(c)) : []
    return R
  }
}).send


// 974	xsh/course	/xsh/course/courseware/list/	获取课件列表
export const courseWares = apiRegister('courseWares', {
  protoId: 974,
  path: '/xsh/course/courseware/list/',
  checkQuery(Q) {
    if (!isOkId(Q.cid)) {
      return ERR_REQ_COURSE_ID
    }
    return NO_ERROR
  },
  formatQuery(Q) {
    const pageNum = Q.pageNum > 0 ? +Q.pageNum : 20
    return {
      ...Q,
      pageNum
    }
  },
  formatResult({
    coursewareList
  }) {
    const list = isArray(coursewareList) ? map(coursewareList, cw => KCourseWare(cw)) : []
    return {
      list
    }
  }
}).send




// 974	xsh/config	/xsh/course/add/order/	添加课程购买的订单
export const courseAddOrder = apiRegister('courseAddOrder', {
  protoId: 974,
  path: '/xsh/course/add/order/',
  checkQuery(Q) {
    if (!isOkId(Q.cid)) {
      return ERR_REQ_COURSE_ID
    }
    return NO_ERROR
  },
  formatResult(R) {
    // R.list = isArray(R.list) ? map(R.list, c => KCourse(c)) : []
    return R
  }
}).send


// 1007	xsh/course	/xsh/course/play/count/	添加 并 查询 播放数
export const playCountSubmit = apiRegister('playCountSubmit', {
  protoId: 1007,
  path: '/xsh/course/play/count/',
  checkQuery(Q) {
    if (!isOkId(Q.id)) {
      return ERR_REQ_COURSE_ID
    }
    return NO_ERROR
  }
}).send
